module.exports = __webpack_public_path__ + "img/bgIcon_8.52368b77.png";